/*
 * Product subtitle: clamped to a single line, with a "More.." toggle that
 * appears only when the text actually overflows that line.
 *
 * The clamp itself is CSS (-webkit-line-clamp: 1). This script only decides
 * whether the toggle is needed — comparing the full content height against the
 * clamped box height — and flips the expanded state on click.
 */
(function () {
  var RESIZE_DEBOUNCE = 150;

  function setup(root) {
    var text = root.querySelector('[data-product-subtitle-text]');
    var toggle = root.querySelector('[data-product-subtitle-toggle]');
    if (!text || !toggle) return;

    function overflows() {
      // Only meaningful while collapsed; expanded, the box grows to fit.
      return text.scrollHeight - text.clientHeight > 1;
    }

    function refresh() {
      if (root.classList.contains('is-expanded')) return;
      toggle.hidden = !overflows();
    }

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded
        ? toggle.dataset.labelLess || 'Less'
        : toggle.dataset.labelMore || 'More..';
      if (!expanded) refresh();
    });

    refresh();

    // Wrapping changes with width, and with the webfont swapping in.
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, RESIZE_DEBOUNCE);
    });

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  }

  function init() {
    document.querySelectorAll('[data-product-subtitle]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
